import type { GameAccessMode } from "@/game/game-mode";
import type { GameSettings } from "@/game/model/game-settings";
import type { IdleState } from "@/game/model/idle-state";

export const GameEvents = {
  StateChanged: "idle-state-changed",
  OfflineApplied: "idle-offline-applied",
  GameModeChanged: "game-mode-changed",
  GameSettingsChanged: "game-settings-changed",
} as const;

export type GameModeChangedPayload = {
  mode: GameAccessMode;
  userId: string;
  canGm: boolean;
};

export type StateChangedPayload = { state: IdleState };
export type GameSettingsChangedPayload = { settings: GameSettings };
